'use strict';
import { module } from '../app';

module.controller('StudyDetailsCtrl', [
  '$scope', '$stateParams', 'studyDetailsViewModel', function ($scope, $stateParams, viewModel) {
    const accessToken = $stateParams.accessToken;
    const sdate = $stateParams.sdate;
    $scope.vm = new viewModel(accessToken, sdate);
  }
]);



// WEBPACK FOOTER //
// ./src/scripts/controllers/studyDetails.js